import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from '../adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { IModel } from 'app/model/base/annotation';
import { parameterizablePasswordOrAKVtoSecretBase, parameterizableSecretBaseToModel } from './azure-key-vault.util';
import { SharePointOnlineFileLinkedService } from 'app/model/linkedservice/sharepoint-online-file.linkedservice';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { GlobalVariables } from 'app/services/globals';
import { Credential, sharePointOnlineAuthTypes } from 'shell-models-lib';
import { ReferenceAdapter } from '../reference.adapter';
import { LinkedServiceAdapter } from './linkedservice.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SharePointOnlineFileLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                tenantId: '*',
                servicePrincipalId: '*',
                servicePrincipalKey: 'secret',
                siteUrl: '*',
                encryptedCredential: '*',
                credential: GlobalVariables.enableConnectorUserAuthCred ? '*' : undefined
            },
            parameters: '*'
        }
    }
})
export class SharePointOnlineFileLinkedServiceAdapter extends LinkedServiceAdapter<SharePointOnlineFileLinkedService> {
    protected supportFirstClassParameterExperience = true;

    // /**
    //  * Update AuthenticationType based on fetched credential type
    //  * @param model linked service model
    //  */
    // public async postToModel(model: SharePointOnlineFileLinkedService): Promise<void> {
    //     let finalAuthType: string = model.authenticationType;
    //     if (model.credential) {
    //         const credType = model.credential.getType();

    //         if (credType === CredentialTypeOptions.ServicePrincipal) {
    //             finalAuthType = AuthenticationType.ServicePrincipal;
    //         } else if (credType === CredentialTypeOptions.UserAuth) {
    //             finalAuthType = AuthenticationType.UserAuth;
    //         }
    //     }
    //     model.authenticationType = finalAuthType;
    // }

    protected modelConstructor(): new () => SharePointOnlineFileLinkedService {
        return SharePointOnlineFileLinkedService;
    }

    protected model(): IModel {
        return SharePointOnlineFileLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(linkedService: SharePointOnlineFileLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.SharePointOnlineFileLinkedService;
        properties.type = Metamodel.modelFor(SharePointOnlineFileLinkedService).name;
        properties.typeProperties = {
            siteUrl: this.valueToResource(linkedService, SharePointOnlineFileLinkedService.SITE_URL),
            tenantId: this.valueToResource(linkedService, SharePointOnlineFileLinkedService.TENANTID_ID),
        };

        if (GlobalVariables.enableConnectorUserAuthCred) {
            if (linkedService.authenticationType === sharePointOnlineAuthTypes.ServicePrincipal) {
                properties.typeProperties.servicePrincipalId = this.valueToResource(linkedService, SharePointOnlineFileLinkedService.SERVICE_PRINCIPAL_ID);
                properties.typeProperties.servicePrincipalKey = parameterizablePasswordOrAKVtoSecretBase(linkedService, SharePointOnlineFileLinkedService.SERVICE_PRINCIPAL_KEY, this.context);
            } else if (linkedService.authenticationType === sharePointOnlineAuthTypes.UserAuth) {
                properties.typeProperties.credential = linkedService.credential
                    ? ReferenceAdapter.toResource(linkedService.credential, this.context) as Model.CredentialReference
                    : undefined;
            }
        } else {
            properties.typeProperties.servicePrincipalId = this.valueToResource(linkedService, SharePointOnlineFileLinkedService.SERVICE_PRINCIPAL_ID);
            properties.typeProperties.servicePrincipalKey = parameterizablePasswordOrAKVtoSecretBase(linkedService, SharePointOnlineFileLinkedService.SERVICE_PRINCIPAL_KEY, this.context);
        }
        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(modelLinkedServiceResource: Model.LinkedServiceResource, linkedService: SharePointOnlineFileLinkedService): Promise<SharePointOnlineFileLinkedService> {
        const prop = modelLinkedServiceResource.properties as Model.SharePointOnlineFileLinkedService;
        const typeProperties = prop.typeProperties;
        ValueAdapter.toModel(linkedService, SharePointOnlineFileLinkedService.SITE_URL, typeProperties.siteUrl);
        ValueAdapter.toModel(linkedService, SharePointOnlineFileLinkedService.TENANTID_ID, typeProperties.tenantId);
        if (GlobalVariables.enableConnectorUserAuthCred) {
            if (typeProperties.servicePrincipalId) {
                linkedService.authenticationType = sharePointOnlineAuthTypes.ServicePrincipal;
                ValueAdapter.toModel(linkedService, SharePointOnlineFileLinkedService.SERVICE_PRINCIPAL_ID, typeProperties.servicePrincipalId);
                parameterizableSecretBaseToModel(linkedService, SharePointOnlineFileLinkedService.SERVICE_PRINCIPAL_KEY, typeProperties.servicePrincipalKey, this.context);
            } else if (typeProperties.credential) {
                linkedService.authenticationType = sharePointOnlineAuthTypes.UserAuth;
                linkedService.credential = ReferenceAdapter.toProxyModel(Metamodel.modelFor(Credential), typeProperties.credential, this.context);
            }
        } else {
            ValueAdapter.toModel(linkedService, SharePointOnlineFileLinkedService.SERVICE_PRINCIPAL_ID, typeProperties.servicePrincipalId);
            parameterizableSecretBaseToModel(linkedService, SharePointOnlineFileLinkedService.SERVICE_PRINCIPAL_KEY, typeProperties.servicePrincipalKey, this.context);
        }
        return linkedService;
    }
}
